import React from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "@apollo/client";

import { GET_SYS_SIZE_POP_SERVED } from "../../../queries/archiveQrys/secureQrys/statewideReportQry";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";
import ChartLegend from "../../reuseableComponents/graphsAndCharts/ChartLegend";
import DeqPieChart from "../../reuseableComponents/graphsAndCharts/DeqPieChart";

const SysSizePopChart = () => {
  const { loading, data, error } = useQuery(GET_SYS_SIZE_POP_SERVED);

  if (loading || error) {
    return (
      <>
        <Row>
          <Col>
            <h3>Population Served By Water System Size</h3>
          </Col>
        </Row>
        <Row>
          <Col>{loading ? <SkeletonLoader width='100%' /> : error ? <ErrorHandler error={error} /> : ""}</Col>
        </Row>
      </>
    );
  }

  const colors = ["#0080b7", "#00afd8", "#636363", "#add361", "#5fa7be"];

  return (
    <>
      <Row>
        <Col>
          <h3>Population Served By Water System Size</h3>
        </Col>
      </Row>
      <Row>
        <Col cypressid='sysSizePopLegend'>
          <ChartLegend data={data.getPopulationBySystemSizeStats} colorArray={colors} />
        </Col>
      </Row>
      <Row>
        <Col cypressid='sysSizePopChart'>
          <DeqPieChart data={data.getPopulationBySystemSizeStats} colorArray={colors} />{" "}
        </Col>
      </Row>
    </>
  );
};
export default SysSizePopChart;
